import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect,
	MultiSelect
} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import MasterService from './../../../services/masterdata.service';
import Matrix from './../../../../shared/components/matrix';
import CONSTANT from './../../../../shared/constants/constant'
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';


export default {
	name: 'serviceareatemplate',
	props: ['selectedEditRow', 'odaChargeId'],

	components: {
		VueElementLoading,
		Paginate,
		BasicSelect,
		vueMultiSelect,
		Matrix,
		Treeselect
	},
	data: function() {
		return {
			SYMBOL_CONFIG: {
				[CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN_EQUAL_TO]: "<=",
				[CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN_EQUAL_TO]: ">=",
				[CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN]: "<",
				[CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN]: ">"
			},
			ODATemplateName: '',
			ODADescription: '',
			distanceSlab: '',
			weightSlab: '',
			//distanceList: [],
			// weightList: [],
			matrixHeaderArray: [],
			matrixVerticalHeaderArray: [],
			matrixTableDataArray: [],
			isMatrixSaveButtonHidden: true,
			isLoading: false,
			selectedDistance: {
				id: null,
				label: null
			},
			selectedWeight: {
				id: null,
				label: null
			},
			distanceList: [],
			weightList: [],
			matrixLabel: {
				horizontal: "Physical Weight (kg)",
				verticle: "Distance (km)"
			},
			odachargeid: null,
			showSelectedDistanceError: false,
			showSelectedWeightError: false
		}
	},
	computed: {

	},
	mounted() {
		this.getSlabList();
		if (this.odaChargeId && this.selectedEditRow) {
			this.selectedDistance.id = this.selectedEditRow.distanceslabid;
			this.selectedWeight.id = this.selectedEditRow.weightslabid;
			this.getOdaChargeDetail(this.odaChargeId);
			this.ODATemplateName = this.selectedEditRow.odatemplatename;
			this.ODADescription = this.selectedEditRow.odatemplatedescription;
		}
		var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userName = userdetail.email;
	},
	methods: {
		showODACharge() {
			this.$emit("goBackToParent")
		},
		async getOdaChargeDetail(odaChargeId) {
			try {
				let payload = {
					odachargeid: odaChargeId
				}
				let result = await MasterService.getOdaDetail(payload);
				this.createMatrixFromOdaExistingDetails(result.data.data.rows);
				// let result = await Promise.all([
				// 	MasterService.getOdaDetail(payload),
				// 	this.getSlabDistanceDetails(this.selectedEditRow.distanceslabid, false),
				// 	this.getSlabWeightDetails(this.selectedEditRow.weightslabid, false)
				// ]);
				// this.selectedDistance.id = this.selectedEditRow.distanceslabid;
				// this.selectedWeight.id = this.selectedEditRow.weightslabid;
				// if (result[0] && result[0].data && result[0].data.data) {
				// 	let matrixData = result[0].data.data.rows;
				// 	this.updateMatrix(matrixData);
				// }
			} catch (err) {
				console.log(err);
			}
		},
		setSelectedDistance(data) {
			if(data.id) {
				this.selectedDistance.id = data.id;
				this.selectedDistance.label = data.label;
				this.showSelectedDistanceError = false;
				this.getSlabDistanceDetails(data.id)
			}
		},

/********Need To Implement Start*************************** */
		groupBy(array, property) {
			var hash = {};
			for (var i = 0; i < array.length; i++) {
				if (!hash[array[i][property]]) hash[array[i][property]] = [];
				hash[array[i][property]].push(array[i]);
			}
			return hash;
		},


		getWithoutDecimalValue(str) {
			let convertedChargeValue = str.toString().split(".");
			convertedChargeValue = convertedChargeValue[1] == "00" ? convertedChargeValue[0] : el.charges;
			return convertedChargeValue
		},

		async createMatrixFromOdaExistingDetails(OdaDataArr) {
			try {
				let matrixVerticalHeaderArray = [];
				let matrixHorizontalHeaderArray = [];
				this.matrixLabel.horizontal = OdaDataArr[0].horizontallabel;
				let splitingWeight = this.groupBy(OdaDataArr, "weightslabsequence");
				let splitingDistance = this.groupBy(OdaDataArr, "distanceslabsequence");
				for (let key in splitingDistance) {
					let el = splitingDistance[key][0];
					let name = `${this.SYMBOL_CONFIG[el.distancelowerlimit]} ${this.getWithoutDecimalValue(el.distancelowerlimitvalue)} to ${this.SYMBOL_CONFIG[el.distancehigherlimit]} ${this.getWithoutDecimalValue(el.distancehigherlimitvalue)}`
					matrixVerticalHeaderArray.push({
						id: key,
						name: name,
						distancehigherlimitvalue: el.distancehigherlimitvalue,
						distancelowerlimitvalue: el.distancelowerlimitvalue,
						distanceslabsequence: key,
						distancelowerlimit: el.distancelowerlimit,
						distancehigherlimit: el.distancehigherlimit
					})
				}
				for (let key in splitingWeight) {
					let el = splitingWeight[key][0];
					let name = `${this.SYMBOL_CONFIG[el.weightlowerlimit]} ${this.getWithoutDecimalValue(el.weightlowerlimitvalue)} to ${this.SYMBOL_CONFIG[el.weighthigherlimit]} ${this.getWithoutDecimalValue(el.weighthigherlimitvalue)}`
					matrixHorizontalHeaderArray.push({
						id: key,
						name: name,
						weighthigherlimitvalue: el.weighthigherlimitvalue,
						weightlowerlimitvalue: el.weightlowerlimitvalue,
						weightslabsequence: key,
						weightlowerlimit: el.weightlowerlimit,
						weighthigherlimit: el.weighthigherlimit
					})
				}

				this.matrixVerticalHeaderArray = matrixVerticalHeaderArray;
				this.matrixHeaderArray = matrixHorizontalHeaderArray;

				if (OdaDataArr) {
					await this.updateMatrix(OdaDataArr);
				}
			} catch (err) {
				console.log(err);
			}
		},
/********Need To Implement End*************************** */

		setSelectedWeight(data) {
			if(data.id) {
				this.selectedWeight.id = data.id;
				this.selectedWeight.label = data.label;
				this.showSelectedWeightError = false;
				this.getSlabWeightDetails(data.id);
			}
		},

		async getSlabDistanceDetails(id, isMatrixCreation = true) {
			try {
				let distanceInputPayload = {
					slabid: id
				}
				this.matrixVerticalHeaderArray = []
				this.isLoading = true;
				let response = await MasterService.getSlabDetails(distanceInputPayload);
				this.isLoading = false;
				response.data.data.slabbreakupdetails.forEach((el) => {
					let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue} to
          ${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`
					this.matrixVerticalHeaderArray.push({
						id: el.slabnumber,
						name: name,
						distancehigherlimitvalue: el.higherlimitvalue,
						distancelowerlimitvalue: el.lowerlimitvalue,
						distanceslabsequence: el.slabnumber,
						distancelowerlimit: el.lowerlimit,
						distancehigherlimit: el.higherlimit
					})
				})
				if (isMatrixCreation) {
					this.createMatrixStructure();
				}

			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},

		async getSlabWeightDetails(id, isMatrixCreation = true) {
			try {
				let weightInputPayload = {
					slabid: id
				}
				this.matrixHeaderArray = [];
				this.isLoading = true;
				let response = await MasterService.getSlabDetails(weightInputPayload);
				this.isLoading = false;
				for(let key in CONSTANT.WEIGHT_TYPE){
					if(CONSTANT.WEIGHT_TYPE[key] == response.data.data.slabsubtype) {
						let firstWord = key.split("_")[0]
						this.matrixLabel.horizontal = firstWord.charAt(0).toUpperCase() + firstWord.toLowerCase().slice(1) + " Weight (kg)"
					}
				  }
				response.data.data.slabbreakupdetails.forEach((el) => {
					let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue} to
          ${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`
					this.matrixHeaderArray.push({
						id: el.slabnumber,
						name: name,
						weighthigherlimitvalue: el.higherlimitvalue,
						weightlowerlimitvalue: el.lowerlimitvalue,
						weightslabsequence: el.slabnumber,
						weightlowerlimit: el.lowerlimit,
						weighthigherlimit: el.higherlimit
					})
				})
				if (isMatrixCreation) {
					this.createMatrixStructure()
				}
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},

		async getSlabList() {
			try {
				let weightInputPayload = {
					slabtype: CONSTANT.SLAB_TYPE.WEIGHT
				}
				let distanceInputPayload = {
					slabtype: CONSTANT.SLAB_TYPE.DISTANCE
				}
				this.isLoading = true;
				let result = await Promise.all([MasterService.getAllSlab(weightInputPayload),
					MasterService.getAllSlab(distanceInputPayload)
				]);
				result[0].data.data.forEach(element => {
					let isdisabled = false;
					if(element.status == 0){
						isdisabled=true
					}

					this.weightList.push({
						id: element.id,
						label: element.slabname,
						isDisabled:isdisabled
					})
				});
				result[1].data.data.forEach(element => {
					let isdisabled = false;
					if(element.status == 0){
						isdisabled=true
					}
					this.distanceList.push({
						id: element.id,
						label: element.slabname,
						isDisabled:isdisabled
					})
				});
				this.isLoading = false;
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},

		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (result) {

				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
		updateMatrix(onEditMatrixArray) {
			this.matrixVerticalHeaderArray.sort((a, b) => (Number(a.distanceslabsequence) > Number(b.distanceslabsequence)) ? 1 : ((Number(b.distanceslabsequence) > Number(a.distanceslabsequence)) ? -1 : 0));
			this.matrixHeaderArray.sort((a, b) => (Number(a.weightslabsequence) > Number(b.weightslabsequence)) ? 1 : ((Number(b.weightslabsequence) > Number(a.weightslabsequence)) ? -1 : 0));
			for (var i = 0; i < this.matrixVerticalHeaderArray.length; i++) {
				let temp = null;
				let tmparr = [];
				for (var k = 0; k < this.matrixHeaderArray.length; k++) {
					temp = null;
					onEditMatrixArray.forEach((el) => {
						if (this.matrixVerticalHeaderArray[i].id == el.distanceslabsequence && this.matrixHeaderArray[k].id == el.weightslabsequence) {
							let convertedChargeValue = el.charges.toString().split(".");
							convertedChargeValue = convertedChargeValue[1] == "00" ? convertedChargeValue[0] : el.charges;
							temp = {
								id: el.id,
								ratevalue: convertedChargeValue,
								source: el.distanceslabsequence,
								destination: el.weightslabsequence,
								distancehigherlimitvalue: el.distancehigherlimitvalue,
								distancelowerlimitvalue: el.distancelowerlimitvalue,
								distanceslabsequence: el.distanceslabsequence,
								distancelowerlimit: el.distancelowerlimit,
								distancehigherlimit: el.distancehigherlimit,

								weighthigherlimitvalue: el.weighthigherlimitvalue,
								weightlowerlimitvalue: el.weightlowerlimitvalue,
								weightslabsequence: el.weightslabsequence,
								weightlowerlimit: el.weightlowerlimit,
								weighthigherlimit: el.weighthigherlimit
							}
						}
					})
					if (!temp) {
						temp = {
							ratevalue: 0,
							source: this.matrixVerticalHeaderArray[i].id,
							destination: this.matrixHeaderArray[k].id,
							distancehigherlimitvalue: this.matrixVerticalHeaderArray[i].distancehigherlimitvalue,
							distancelowerlimitvalue: this.matrixVerticalHeaderArray[i].distancelowerlimitvalue,
							distanceslabsequence: this.matrixVerticalHeaderArray[i].distanceslabsequence,
							distancelowerlimit: this.matrixVerticalHeaderArray[i].distancelowerlimit,
							distancehigherlimit: this.matrixVerticalHeaderArray[i].distancehigherlimit,

							weighthigherlimitvalue: this.matrixHeaderArray[k].weighthigherlimitvalue,
							weightlowerlimitvalue: this.matrixHeaderArray[k].weightlowerlimitvalue,
							weightslabsequence: this.matrixHeaderArray[k].weightslabsequence,
							weightlowerlimit: this.matrixHeaderArray[k].weightlowerlimit,
							weighthigherlimit: this.matrixHeaderArray[k].weighthigherlimit
						}
					}
					tmparr.push(temp)
				}
				this.matrixTableDataArray.push(tmparr)
			}
		},

		createMatrixStructure() {
			if (this.matrixVerticalHeaderArray.length == 0 || this.matrixHeaderArray.length == 0) {
				return;
			}
			this.matrixTableDataArray = [];
			this.matrixVerticalHeaderArray.sort((a, b) => (a.distanceslabsequence > b.distanceslabsequence) ? 1 : ((b.distanceslabsequence > a.distanceslabsequence) ? -1 : 0));
			this.matrixHeaderArray.sort((a, b) => (a.weightslabsequence > b.weightslabsequence) ? 1 : ((b.weightslabsequence > a.weightslabsequence) ? -1 : 0));
			for (var i = 0; i < this.matrixVerticalHeaderArray.length; i++) {
				var tmparr = [];
				for (var k = 0; k < this.matrixHeaderArray.length; k++) {
					var temp2 = {
						ratevalue: undefined,
						source: this.matrixVerticalHeaderArray[i].id,
						destination: this.matrixHeaderArray[k].id,
						distancehigherlimitvalue: this.matrixVerticalHeaderArray[i].distancehigherlimitvalue,
						distancelowerlimitvalue: this.matrixVerticalHeaderArray[i].distancelowerlimitvalue,
						distanceslabsequence: this.matrixVerticalHeaderArray[i].distanceslabsequence,
						distancelowerlimit: this.matrixVerticalHeaderArray[i].distancelowerlimit,
						distancehigherlimit: this.matrixVerticalHeaderArray[i].distancehigherlimit,

						weighthigherlimitvalue: this.matrixHeaderArray[k].weighthigherlimitvalue,
						weightlowerlimitvalue: this.matrixHeaderArray[k].weightlowerlimitvalue,
						weightslabsequence: this.matrixHeaderArray[k].weightslabsequence,
						weightlowerlimit: this.matrixHeaderArray[k].weightlowerlimit,
						weighthigherlimit: this.matrixHeaderArray[k].weighthigherlimit
					}
					tmparr.push(temp2)
				}
				this.matrixTableDataArray.push(tmparr)
			}
		},
		getUpdatedMatrixData() {

		},

		saveInfo() {
			this.$validator.validateAll().then((result) => {
				if (result) {

					if (this.odaChargeId && !this.selectedDistance.id && !this.selectedWeight.id) {
						this.createTemplate(this.matrixTableDataArray);
						return;
					} else if (this.selectedDistance.id && this.selectedWeight.id) {
						this.createTemplate(this.matrixTableDataArray);
						return;
					}
					if (!this.selectedDistance.id) {
						this.showSelectedDistanceError = true
					}
					if (!this.selectedWeight.id) {
						this.showSelectedWeightError = true
					}
				} else {
					if (this.odaChargeId && !this.selectedDistance.id && !this.selectedWeight.id) {
						return;
					}
					if (!this.selectedDistance.id) {
						this.showSelectedDistanceError = true
					}
					if (!this.selectedWeight.id) {
						this.showSelectedWeightError = true
					}
				}
			}).catch((err) => {
				console.log('errors exist', err)
			});
		},
		async createTemplate(matrixTableDataArray) {
			let finalList = [];
			for (var i = 0; i < matrixTableDataArray.length; i++) {
				for (var j = 0; j < matrixTableDataArray[i].length; j++) {
					if(!matrixTableDataArray[i][j].ratevalue && matrixTableDataArray[i][j].ratevalue !==0){
						this.$alert("All fields are mandatory. Please check ODA Matrix", "", "error");
						return;
					  }
					finalList.push({
						odadetailid: Number(matrixTableDataArray[i][j].id) || 0,
						charges: Number(matrixTableDataArray[i][j].ratevalue),

						distancehigherlimitvalue: Number(matrixTableDataArray[i][j].distancehigherlimitvalue),
						distancelowerlimitvalue: Number(matrixTableDataArray[i][j].distancelowerlimitvalue),
						distanceslabsequence: Number(matrixTableDataArray[i][j].distanceslabsequence),
						distancelowerlimit: matrixTableDataArray[i][j].distancelowerlimit,
						distancehigherlimit: matrixTableDataArray[i][j].distancehigherlimit,

						weighthigherlimitvalue: Number(matrixTableDataArray[i][j].weighthigherlimitvalue),
						weightlowerlimitvalue: Number(matrixTableDataArray[i][j].weightlowerlimitvalue),
						weightslabsequence: Number(matrixTableDataArray[i][j].weightslabsequence),
						weightlowerlimit: matrixTableDataArray[i][j].weightlowerlimit,
						weighthigherlimit: matrixTableDataArray[i][j].weighthigherlimit
					})
				}
			}
			if (finalList.length == 0) {
				this.$alert("No data available", "ODA Charge Template", "error");
				return false;
			} else {
				let postData = {
					horizontallabel: this.matrixLabel.horizontal,
					odatemplatename: this.ODATemplateName.trim(),
					odatemplatedescription: this.ODADescription.trim(),
					distanceslabid: this.selectedDistance.id,
					weightslabid: this.selectedWeight.id,
					createdby: this.userName,
					lastmodifiedby: this.userName,
					matrix: finalList

				};
				if (this.odaChargeId) {
					postData.odachargeid = this.odaChargeId;
				}
				try {
					this.isLoading = true;
					let result = await MasterService.saveOdaCharge(postData);
					this.isLoading = false;
					if (result.data.code == 200) {
						this.$alert(result.data.message, this.ODATemplateName, "success");
						this.$emit("goBackToParent");
					} else {
						this.$alert(result.data.message, this.ODATemplateName, "error");
					}
				} catch (err) {
					this.isLoading = false;
					console.log(err);
				}
			}
		},
	}
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ODAChargeTemplate/createODACharge/createODACharge.component.js